<section class="work">
  <div class="work-txt">
    <h1 class="header-txt">{{ "work.headline" | translate }}</h1>
  </div>

  <div class="cards">
    <article
      class="card"
      [class.card--collapsed]="!isProjectExpanded[0]"
      [class.card--expanded]="isProjectExpanded[0]"
    >
      <header>
        <h1 class="no">1</h1>
        <span>{{ "work.project1.title" | translate }}</span>
      </header>

      <section class="first-project">
        <div class="project-container">
          <div>
            <div>
              <div class="ellipse-container">
                <img
                  class="ellipse"
                  src="assets/img/icons/project_details/ellipse.png"
                />
                <span class="project-span">
                  {{ "work.project1.about" | translate }}
                </span>
              </div>
              <p>
                {{ "work.project1.about_text" | translate }}
              </p>
            </div>
          </div>
          <div class="ellipse-container project-details">
            <img
              class="ellipse"
              src="assets/img/icons/project_details/ellipse.png"
            />
            <span class="project-span">
              {{ "work.project1.tech" | translate }}
            </span>
          </div>
          <p class="project-details">
            {{ "work.project1.tech_list" | translate }}
          </p>
        </div>
        <div class="cta project-details">
          <img class="shot" src="assets/img/screenshots/join.png" alt="Join" />
          <div class="btn-container">
            <a
              class="btn btn--ghost"
              href="https://github.com/EbubekirElicora/join_428"
              target="_blank"
              >GitHub</a
            >
            <a
              class="btn"
              href="https://ebubekir-elicora.de/Join_428/html/log_in.html"
              target="_blank"
              rel="noopener"
              >Live Test</a
            >
          </div>
        </div>
      </section>
      <div class="last-txt project-details">
        <div class="ellipse-container">
          <img
            class="ellipse"
            src="assets/img/icons/project_details/ellipse.png"
          />
          <span class="project-span">
            {{ "work.project1.team" | translate }}
          </span>
        </div>
        <p>{{ "work.project1.team_text" | translate }}</p>
      </div>
      <div class="cta mobile project-details">
        <img class="shot" src="assets/img/screenshots/join.png" alt="Join" />
        <div class="btn-container">
          <a
            class="btn btn--ghost"
            href="https://github.com/EbubekirElicora/join_428"
            target="_blank"
            >GitHub</a
          >
          <a
            class="btn"
            href="https://ebubekir-elicora.de/Join_428/html/log_in.html"
            target="_blank"
            rel="noopener"
            >Live Test</a
          >
        </div>
      </div>
      <button
        *ngIf="!isProjectExpanded[0]"
        class="project-toggle project-toggle--inside"
        type="button"
        (click)="toggleProject(0)"
      >
        <span>{{ getProjectToggleLabel(0) | translate }}</span>
        <img [src]="getProjectToggleIcon(0)" alt="" />
      </button>
    </article>
    <button
      *ngIf="isProjectExpanded[0]"
      class="project-toggle project-toggle--outside"
      type="button"
      (click)="toggleProject(0)"
    >
      <span>{{ getProjectToggleLabel(0) | translate }}</span>
      <img [src]="getProjectToggleIcon(0)" alt="" />
    </button>

    <article
      class="card"
      [class.card--collapsed]="!isProjectExpanded[1]"
      [class.card--expanded]="isProjectExpanded[1]"
    >
      <header>
        <h1 class="no">2</h1>
        <span>{{ "work.project2.title" | translate }}</span>
      </header>

      <section class="second-project">
        <div class="project-container">
          <div>
            <div>
              <div class="ellipse-container">
                <img
                  class="ellipse"
                  src="assets/img/icons/project_details/ellipse.png"
                />
                <span class="project-span">
                  {{ "work.project2.about" | translate }}
                </span>
              </div>
              <p>
                {{ "work.project2.about_text" | translate }}
              </p>
            </div>
          </div>

          <div class="ellipse-container project-details">
            <img
              class="ellipse"
              src="assets/img/icons/project_details/ellipse.png"
            />
            <span class="project-span">
              {{ "work.project2.tech" | translate }}
            </span>
          </div>
          <p class="project-details">
            {{ "work.project2.tech_list" | translate }}
          </p>
        </div>

        <div class="cta project-details">
          <img
            class="shot"
            src="assets/img/screenshots/pollo_Loco.png"
            alt="Pollo Loco"
          />
          <div class="btn-container">
            <a
              class="btn btn--ghost"
              href="https://github.com/EbubekirElicora/Projekt_El_Polo_Loco_Ebubekir_Elicora"
              target="_blank"
              >GitHub</a
            >
            <a
              class="btn"
              href="https://ebubekir-elicora.de/Projekt_El_Polo_Loco_Ebubekir_Elicora/index.html"
              target="_blank"
              rel="noopener"
              >Live Test</a
            >
          </div>
        </div>
      </section>

      <div class="last-txt-second project-details">
        <div class="ellipse-container">
          <img
            class="ellipse"
            src="assets/img/icons/project_details/ellipse.png"
          />
          <span class="project-span">
            {{ "work.project2.learned" | translate }}
          </span>
        </div>
        <p>{{ "work.project2.learned_text" | translate }}</p>
      </div>

      <div class="cta mobile project-details">
        <img
          class="shot"
          src="assets/img/screenshots/pollo_Loco.png"
          alt="Pollo Loco"
        />
        <div class="btn-container">
          <a
            class="btn btn--ghost"
            href="https://github.com/EbubekirElicora/Projekt_El_Polo_Loco_Ebubekir_Elicora"
            target="_blank"
            >GitHub</a
          >
          <a
            class="btn"
            href="https://ebubekir-elicora.de/Projekt_El_Polo_Loco_Ebubekir_Elicora/index.html"
            target="_blank"
            rel="noopener"
            >Live Test</a
          >
        </div>
      </div>

      <button
        *ngIf="!isProjectExpanded[1]"
        class="project-toggle project-toggle--inside"
        type="button"
        (click)="toggleProject(1)"
      >
        <span>{{ getProjectToggleLabel(1) | translate }}</span>
        <img [src]="getProjectToggleIcon(1)" alt="" />
      </button>
    </article>

    <button
      *ngIf="isProjectExpanded[1]"
      class="project-toggle project-toggle--outside"
      type="button"
      (click)="toggleProject(1)"
    >
      <span>{{ getProjectToggleLabel(1) | translate }}</span>
      <img [src]="getProjectToggleIcon(1)" alt="" />
    </button>

    <article
      class="card"
      [class.card--collapsed]="!isProjectExpanded[2]"
      [class.card--expanded]="isProjectExpanded[2]"
    >
      <header>
        <h1 class="no">3</h1>
        <span>{{ "work.project3.title" | translate }}</span>
      </header>

      <section class="third-project">
        <div class="project-container">
          <div>
            <div>
              <div class="ellipse-container">
                <img
                  class="ellipse"
                  src="assets/img/icons/project_details/ellipse.png"
                />
                <span class="project-span">
                  {{ "work.project3.about" | translate }}
                </span>
              </div>
              <p>
                {{ "work.project3.about_text" | translate }}
              </p>
            </div>
          </div>

          <div class="ellipse-container project-details">
            <img
              class="ellipse"
              src="assets/img/icons/project_details/ellipse.png"
            />
            <span class="project-span">
              {{ "work.project3.tech" | translate }}
            </span>
          </div>
          <p class="project-details">
            {{ "work.project3.tech_list" | translate }}
          </p>
        </div>

        <div class="cta project-details">
          <img
            class="shot"
            src="assets/img/screenshots/ringOfFire.png"
            alt="Ring of Fire"
          />
          <div class="btn-container">
            <a
              class="btn btn--ghost"
              href="https://github.com/EbubekirElicora/ringOfFire"
              target="_blank"
              >GitHub</a
            >
            <a
              class="btn"
              href="https://ebubekir-elicora.de/ring-of-fire/"
              target="_blank"
              >Live Test</a
            >
          </div>
        </div>
      </section>

      <div class="last-txt-third project-details">
        <div class="ellipse-container">
          <img
            class="ellipse"
            src="assets/img/icons/project_details/ellipse.png"
          />
          <span class="project-span">
            {{ "work.project3.team" | translate }}
          </span>
        </div>
        <p>{{ "work.project3.team_text" | translate }}</p>
      </div>

      <div class="cta mobile project-details">
        <img
          class="shot"
          src="assets/img/screenshots/ringOfFire.png"
          alt="Ring of Fire"
        />
        <div class="btn-container">
          <a
            class="btn btn--ghost"
            href="https://github.com/EbubekirElicora/ringOfFire"
            target="_blank"
            >GitHub</a
          >
          <a
            class="btn"
            href="https://ebubekir-elicora.de/ring-of-fire/"
            target="_blank"
            >Live Test</a
          >
        </div>
      </div>

      <button
        *ngIf="!isProjectExpanded[2]"
        class="project-toggle project-toggle--inside"
        type="button"
        (click)="toggleProject(2)"
      >
        <span>{{ getProjectToggleLabel(2) | translate }}</span>
        <img [src]="getProjectToggleIcon(2)" alt="" />
      </button>
    </article>

    <button
      *ngIf="isProjectExpanded[2]"
      class="project-toggle project-toggle--outside"
      type="button"
      (click)="toggleProject(2)"
    >
      <span>{{ getProjectToggleLabel(2) | translate }}</span>
      <img [src]="getProjectToggleIcon(2)" alt="" />
    </button>

    <!-- PROJECT 4: KANMIND -->
    <article
      class="card"
      [class.card--collapsed]="!isProjectExpanded[3]"
      [class.card--expanded]="isProjectExpanded[3]"
    >
      <header>
        <h1 class="no">4</h1>
        <span>{{ "work.project4.title" | translate }}</span>
      </header>

      <section class="first-project">
        <div class="project-container">
          <div>
            <div>
              <div class="ellipse-container">
                <img
                  class="ellipse"
                  src="assets/img/icons/project_details/ellipse.png"
                  alt=""
                />
                <span class="project-span">
                  {{ "work.project4.about" | translate }}
                </span>
              </div>

              <p>
                {{ "work.project4.about_text" | translate }}
              </p>
            </div>
          </div>

          <div class="ellipse-container project-details">
            <img
              class="ellipse"
              src="assets/img/icons/project_details/ellipse.png"
              alt=""
            />
            <span class="project-span">
              {{ "work.project4.tech" | translate }}
            </span>
          </div>

          <p class="project-details">
            {{ "work.project4.tech_list" | translate }}
          </p>
        </div>

        <div class="cta project-details">
          <img
            class="shot"
            src="assets/img/screenshots/kanmind.png"
            alt="KanMind"
          />

          <div class="btn-container">
            <a
              class="btn btn--ghost"
              href="https://github.com/EbubekirElicora/KanMind"
              target="_blank"
              rel="noopener"
            >
              GitHub
            </a>

            <a
              class="btn"
              href="https://kanmind.ebubekir-elicora.de/"
              target="_blank"
              rel="noopener"
            >
              Live Test
            </a>
          </div>
        </div>
      </section>

      <div class="last-txt project-details">
        <div class="ellipse-container">
          <img
            class="ellipse"
            src="assets/img/icons/project_details/ellipse.png"
            alt=""
          />
          <span class="project-span">
            {{ "work.project4.learned" | translate }}
          </span>
        </div>

        <p>{{ "work.project4.learned_text" | translate }}</p>
      </div>

      <div class="cta mobile project-details">
        <img
          class="shot"
          src="assets/img/screenshots/kanmind.png"
          alt="KanMind"
        />

        <div class="btn-container">
          <a
            class="btn btn--ghost"
            href="https://github.com/EbubekirElicora/KanMind"
            target="_blank"
            rel="noopener"
          >
            GitHub
          </a>

          <a
            class="btn"
            href="https://kanmind.ebubekir-elicora.de/"
            target="_blank"
            rel="noopener"
          >
            Live Test
          </a>
        </div>
      </div>

      <button
        *ngIf="!isProjectExpanded[3]"
        class="project-toggle project-toggle--inside"
        type="button"
        (click)="toggleProject(3)"
      >
        <span>{{ getProjectToggleLabel(3) | translate }}</span>
        <img [src]="getProjectToggleIcon(3)" alt="" />
      </button>
    </article>

    <button
      *ngIf="isProjectExpanded[3]"
      class="project-toggle project-toggle--outside"
      type="button"
      (click)="toggleProject(3)"
    >
      <span>{{ getProjectToggleLabel(3) | translate }}</span>
      <img [src]="getProjectToggleIcon(3)" alt="" />
    </button>

    <!-- PROJECT 5: CODERR -->
    <article
      class="card"
      [class.card--collapsed]="!isProjectExpanded[4]"
      [class.card--expanded]="isProjectExpanded[4]"
    >
      <header>
        <h1 class="no">5</h1>
        <span>{{ "work.project5.title" | translate }}</span>
      </header>

      <section class="second-project">
        <div class="project-container">
          <div>
            <div>
              <div class="ellipse-container">
                <img
                  class="ellipse"
                  src="assets/img/icons/project_details/ellipse.png"
                  alt=""
                />
                <span class="project-span">
                  {{ "work.project5.about" | translate }}
                </span>
              </div>

              <p>
                {{ "work.project5.about_text" | translate }}
              </p>
            </div>
          </div>

          <div class="ellipse-container project-details">
            <img
              class="ellipse"
              src="assets/img/icons/project_details/ellipse.png"
              alt=""
            />
            <span class="project-span">
              {{ "work.project5.tech" | translate }}
            </span>
          </div>

          <p class="project-details">
            {{ "work.project5.tech_list" | translate }}
          </p>
        </div>

        <div class="cta project-details">
          <img
            class="shot"
            src="assets/img/screenshots/coderr.png"
            alt="Coderr"
          />

          <div class="btn-container">
            <a
              class="btn btn--ghost"
              href="https://github.com/EbubekirElicora/Coderr"
              target="_blank"
              rel="noopener"
            >
              GitHub
            </a>

            <a
              class="btn"
              href="https://coderr.ebubekir-elicora.de/"
              target="_blank"
              rel="noopener"
            >
              Live Test
            </a>
          </div>
        </div>
      </section>

      <div class="last-txt-second project-details">
        <div class="ellipse-container">
          <img
            class="ellipse"
            src="assets/img/icons/project_details/ellipse.png"
            alt=""
          />
          <span class="project-span">
            {{ "work.project5.learned" | translate }}
          </span>
        </div>

        <p>{{ "work.project5.learned_text" | translate }}</p>
      </div>

      <div class="cta mobile project-details">
        <img
          class="shot"
          src="assets/img/screenshots/coderr.png"
          alt="Coderr"
        />

        <div class="btn-container">
          <a
            class="btn btn--ghost"
            href="https://github.com/EbubekirElicora/Coderr"
            target="_blank"
            rel="noopener"
          >
            GitHub
          </a>

          <a
            class="btn"
            href="https://coderr.ebubekir-elicora.de/"
            target="_blank"
            rel="noopener"
          >
            Live Test
          </a>
        </div>
      </div>

      <button
        *ngIf="!isProjectExpanded[4]"
        class="project-toggle project-toggle--inside"
        type="button"
        (click)="toggleProject(4)"
      >
        <span>{{ getProjectToggleLabel(4) | translate }}</span>
        <img [src]="getProjectToggleIcon(4)" alt="" />
      </button>
    </article>

    <button
      *ngIf="isProjectExpanded[4]"
      class="project-toggle project-toggle--outside"
      type="button"
      (click)="toggleProject(4)"
    >
      <span>{{ getProjectToggleLabel(4) | translate }}</span>
      <img [src]="getProjectToggleIcon(4)" alt="" />
    </button>

    <!-- PROJECT 6: QUIZLY -->
    <article
      class="card"
      [class.card--collapsed]="!isProjectExpanded[5]"
      [class.card--expanded]="isProjectExpanded[5]"
    >
      <header>
        <h1 class="no">6</h1>
        <span>{{ "work.project6.title" | translate }}</span>
      </header>

      <section class="third-project">
        <div class="project-container">
          <div>
            <div>
              <div class="ellipse-container">
                <img
                  class="ellipse"
                  src="assets/img/icons/project_details/ellipse.png"
                  alt=""
                />
                <span class="project-span">
                  {{ "work.project6.about" | translate }}
                </span>
              </div>

              <p>
                {{ "work.project6.about_text" | translate }}
              </p>
            </div>
          </div>

          <div class="ellipse-container project-details">
            <img
              class="ellipse"
              src="assets/img/icons/project_details/ellipse.png"
              alt=""
            />
            <span class="project-span">
              {{ "work.project6.tech" | translate }}
            </span>
          </div>

          <p class="project-details">
            {{ "work.project6.tech_list" | translate }}
          </p>
        </div>

        <div class="cta project-details">
          <img
            class="shot"
            src="assets/img/screenshots/quizly.png"
            alt="Quizly"
          />

          <div class="btn-container">
            <a
              class="btn btn--ghost"
              href="https://github.com/EbubekirElicora/Quizly"
              target="_blank"
              rel="noopener"
            >
              GitHub
            </a>

            <a
              class="btn"
              href="https://quizly.ebubekir-elicora.de/"
              target="_blank"
              rel="noopener"
            >
              Live Test
            </a>
          </div>
        </div>
      </section>

      <div class="last-txt-third project-details">
        <div class="ellipse-container">
          <img
            class="ellipse"
            src="assets/img/icons/project_details/ellipse.png"
            alt=""
          />
          <span class="project-span">
            {{ "work.project6.learned" | translate }}
          </span>
        </div>

        <p>{{ "work.project6.learned_text" | translate }}</p>
      </div>

      <div class="cta mobile project-details">
        <img
          class="shot"
          src="assets/img/screenshots/quizly.png"
          alt="Quizly"
        />

        <div class="btn-container">
          <a
            class="btn btn--ghost"
            href="https://github.com/EbubekirElicora/Quizly"
            target="_blank"
            rel="noopener"
          >
            GitHub
          </a>

          <a
            class="btn"
            href="https://quizly.ebubekir-elicora.de/"
            target="_blank"
            rel="noopener"
          >
            Live Test
          </a>
        </div>
      </div>

      <button
        *ngIf="!isProjectExpanded[5]"
        class="project-toggle project-toggle--inside"
        type="button"
        (click)="toggleProject(5)"
      >
        <span>{{ getProjectToggleLabel(5) | translate }}</span>
        <img [src]="getProjectToggleIcon(5)" alt="" />
      </button>
    </article>

    <button
      *ngIf="isProjectExpanded[5]"
      class="project-toggle project-toggle--outside"
      type="button"
      (click)="toggleProject(5)"
    >
      <span>{{ getProjectToggleLabel(5) | translate }}</span>
      <img [src]="getProjectToggleIcon(5)" alt="" />
    </button>
  </div>
</section>

<img
  class="next-arrow"
  src="assets/img/icons/arrows/arrow_right.png"
  alt="Weiter"
  role="button"
  tabindex="0"
  (click)="onNext()"
  (keydown.enter)="onNext()"
  (keydown.space)="onNext()"
/>
